import { ReactComponent as SearchIllustration } from 'images/search-illustration.svg';
import styled from '@emotion/styled';

export const SearchIllustrationIcon = styled(SearchIllustration)({
  marginTop: 74,
  marginBottom: 40,
});
